export const TOP_CONDITION_SETTINGS = [
  { key: "fixzins_03", type: "float", label: "Fixzins 3 Jahre", infoLabel: "Fix auf 3 Jahre", durationMonths: 36 },
  { key: "fixzins_05", type: "float", label: "Fixzins 5 Jahre", infoLabel: "Fix auf 5 Jahre", durationMonths: 60 },
  { key: "fixzins_06", type: "float", label: "Fixzins 6 Jahre", infoLabel: "Fix auf 6 Jahre", durationMonths: 72 },
  { key: "fixzins_10", type: "float", label: "Fixzins 10 Jahre", infoLabel: "Fix auf 10 Jahre", durationMonths: 120 },
  { key: "fixzins_15", type: "float", label: "Fixzins 15 Jahre", infoLabel: "Fix auf 15 Jahre", durationMonths: 180 },
  { key: "fixzins_20", type: "float", label: "Fixzins 20 Jahre", infoLabel: "Fix auf 20 Jahre", durationMonths: 240 },
  { key: "fixzins_25", type: "float", label: "Fixzins 25 Jahre", infoLabel: "Fix auf 25 Jahre", durationMonths: 300 },
  { key: "varzins3m", type: "float", label: "Variabel (3m Euribor)" },
  { key: "zins_comment", type: "string", label: "Anmerkung (für alle sichtbar)" },
];

export const TOP_CONDITIONS_UPDATED_EVENT = "fccm:topConditionsUpdated";

export const TOP_FIXED_RATE_SETTINGS = TOP_CONDITION_SETTINGS.filter((setting) =>
  setting.key.startsWith("fixzins_")
);

export const TOP_FIXED_RATE_DURATION_BY_KEY = TOP_FIXED_RATE_SETTINGS.reduce(
  (mapping, setting) => {
    mapping[setting.key] = setting.durationMonths;
    return mapping;
  },
  {}
);

export const TOP_AGENT_NOTE_SETTINGS = [
  ...TOP_CONDITION_SETTINGS.filter(({ type }) => type === "float").map(({ key }) => ({
    key: `${key}_agent_note`, type: "string", label: "Hinweis für Agenten",
  })),
  { key: "zins_agent_comment", type: "string", label: "Anmerkung nur für Agenten" },
];

export const canViewAgentNotes = (role) => ["administrator", "agent"].includes(role);

export const getTopConditionSettings = (role) => [
  ...TOP_CONDITION_SETTINGS,
  ...(canViewAgentNotes(role) ? TOP_AGENT_NOTE_SETTINGS : []),
];
